import { HttpClient, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Client } from '../Module/Client.model';
import { Observable } from 'rxjs';
import { PaymentDetails } from '../Module/PayementDetails.model';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ClientService {
  private get apiUrl(): string {
    return `${environment.apiUrl}/clients`;
  }
  
  constructor(private http:HttpClient) { }
  
  addClient(client:Client):Observable<HttpResponse<Client>>{
    console.log(client);
    return this.http.post<Client>(this.apiUrl, client, { observe: 'response' });
  }
  
  listClients():Observable<Client[]>{
    return this.http.get<Client[]>(this.apiUrl);
  }
  
  countClients():Observable<number>{
    return this.http.get<number>(`${this.apiUrl}/count`);
  }
  
  updateClient(id: number, client: Client): Observable<Client> {
    return this.http.put<Client>(`${this.apiUrl}/${id}`, client);
  }

  getClientById(id: number): Observable<Client> {
    return this.http.get<Client>(`${this.apiUrl}/${id}`);
  }
  
  getClientPaymentSummary(clientId: number): Observable<PaymentDetails> {
    return this.http.get<PaymentDetails>(`${this.apiUrl}/${clientId}/payment-summary`);
  }
}
